import ErrorView from '@/components/error.vue';
import { h } from 'vue'
import { getContext } from './app-context';

export default function (view) {
    return {
        data() {
            return {};
        },
        async beforeCreate() {
            await getContext.call(this);
        },
        created() {
        },
        computed: {
            pageMessage() {
                return this.$store.state.pageMessage || {};
            }
        },
        methods: {

        },

        render() {
            if (this.pageMessage.code) {
                return h(ErrorView, {
                    data: this.pageMessage
                });
            }else {
                return h(view);
            }
        }
    }
}
